import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBoseComponent } from './simple-icons-bose.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBoseComponent ],
    exports:      [ SimpleIconsBoseComponent ],
    bootstrap:    []
})
export class SimpleIconsBoseModule {}
